module.exports = __webpack_public_path__ + "img/gdems-code.9bfe6329.png";